// Direction B "Ink Header" launcher — 56×56 warm-ink circle, white hairline
// chat icon, hover lifts 2px with a heavier shadow. Optional unread badge
// (14×14 brand-pink circle, top-right, 2px white border) shows on returning
// visitors with new agent activity.
//
// Decision: no Mikla wordmark on the launcher. Per BRAND.md sec 2 + Direction
// B handoff, brand identity lives inside the widget (header avatar + powered-by
// footer). The launcher itself is a neutral "open chat" affordance — its
// shape + warm-ink color carry the design language, the icon stays generic.
//
// z-index 2147483645 sits one below the panel (2147483646) so the panel can
// overlay the launcher on small screens (mobile fullscreen modal per spec sec 1.10).

import { CHAT_BUBBLE_SVG } from '../icons/icons'

export interface ChatLauncherProps {
  onClick: () => void
  // Optional unread count. Renders the brand-pink badge top-right when > 0.
  // For v1 always 0; reserved for the proactive-message follow-up (D55).
  unreadCount?: number
}

export function ChatLauncher({ onClick, unreadCount = 0 }: ChatLauncherProps) {
  const hasUnread = unreadCount > 0
  return (
    <button
      type="button"
      data-testid="chat-launcher"
      onClick={onClick}
      aria-label="Open chat"
      aria-expanded="false"
      className="fixed bottom-[18px] right-[18px] w-14 h-14 rounded-full bg-warmink hover:bg-warmink-hover text-white shadow-launcher hover:shadow-launcher-hover hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center group"
      style={{ zIndex: 2147483645 }}
    >
      <span
        dangerouslySetInnerHTML={{ __html: CHAT_BUBBLE_SVG }}
        className="w-[22px] h-[22px] inline-block"
      />
      {hasUnread && (
        <span
          data-testid="launcher-unread-badge"
          className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-accent text-white border-2 border-white font-mono text-[9px] font-semibold flex items-center justify-center leading-none"
          aria-label={`${unreadCount} unread message${unreadCount === 1 ? '' : 's'}`}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  )
}
